"use client";
import React, { useState } from 'react';
import TemplateSettingsDialog from './TemplateSettingsDialog.tsx';
import { Block } from '../../interfaces.ts';
import LocaleFieldWrapper from '../../components/LocaleFieldWrapper.tsx';
import { useLocale } from '../../context/localeContext.tsx';

interface ApplyButtonTemplateSettingsDialogProps {
  block: Block;
  onClose: () => void;
  onSave: (updatedBlock: Block) => void;
  availableLocales: string[];
  fallbackLocale?: string;
}

const ApplyButtonTemplateSettingsDialog: React.FC<ApplyButtonTemplateSettingsDialogProps> = ({ 
  block, 
  onClose, 
  onSave,
  availableLocales
}) => {
  const { activeLocale } = useLocale();
  
  // Local state for label (not part of context)
  const [localeLabel, setLocaleLabel] = useState<{
    [key: string]: string;
  }>(
    availableLocales.reduce((acc: any, locale: string) => {
      acc[locale] = block.defaultContent?.[locale]?.label || '';
      return acc;
    }, {})
  );

  const handleSave = () => {
    onSave({
      ...block,
      defaultContent: {
        ...block.defaultContent,
        [activeLocale]: {
          label: localeLabel[activeLocale]
        }
      }
    });
  };

  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocaleLabel((prev) => ({
      ...prev,
      [activeLocale]: e.target.value,
    }));
  };

  return (
    <TemplateSettingsDialog title="Apply Button Settings" onClose={onClose} onSave={handleSave}>
      <div className="mt-4">
        <LocaleFieldWrapper>
          <label className="block mb-2">
            Default Label ({activeLocale.toUpperCase()}):
            <input
              type="text"
              className="w-full border border-solid border-gray-300 rounded mt-1 p-1"
              value={localeLabel[activeLocale] || ''}
              onChange={handleLabelChange}
            />
          </label>
        </LocaleFieldWrapper>
      </div>
    </TemplateSettingsDialog>
  );
};

export default ApplyButtonTemplateSettingsDialog;